import $ from 'jquery';
import gsap from 'gsap';

class AnimationTextRevealItem {
    constructor(el, index) {
        this.render(el, index);
    }

    checkViewportVisibility() {
        var bounding = this.element.get(0).getBoundingClientRect();

        if (bounding.height != 0 && bounding.width != 0) {
            if (bounding.top > (window.innerHeight)) {
                this.hide();
            } else if (bounding.top < (window.innerHeight - (bounding.height / 4))) {
                this.show();
            }
        } else {
            this.hide();
        }
    }

    hide() {
        if (this.visible) {
            if (this.repeat) {
                this.visible = false;
                gsap.killTweensOf(this.element);
                gsap.set(this.element, { opacity: 0 });
            }
        }
    }

    show() {
        if (!this.visible) {
            this.visible = true;
            gsap.killTweensOf(this.element);
            gsap.fromTo(this.element, { opacity: 0, y: 0 }, { duration: 0.6, ease: "power3.out", opacity: 1, y: 0, delay: 0.2 });
        }
    }

    animate() {
        this.checkViewportVisibility();
        window.requestAnimationFrame(this.animate.bind(this));
    }

    render(el, index) {
        this.element = $(el);
        this.visible = false;
        this.repeat = false;

        gsap.set(this.element, { opacity: 0 });

        this.animate();
    }
}

class AnimationTextReveal {
    static get EVENT() {
        return {

        }
    }

    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new AnimationTextRevealItem(el, index);
    }
}

export default AnimationTextReveal;